/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Invite_Code_TitleInputs */

const en_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter Invite Code`)
};

const ar_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدخل رمز الدعوة`)
};

const de_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungscode eingeben`)
};

const es_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce el código de invitación`)
};

const fr_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir le code d’invitation`)
};

const it_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci codice invito`)
};

const ja_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待コードを入力`)
};

const ko_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대 코드 입력`)
};

const pt_br_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir código de convite`)
};

const ru_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите код приглашения`)
};

const th_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอกรหัสเชิญ`)
};

const tr_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet kodunu gir`)
};

const zh_cn_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入邀请码`)
};

const zh_tw_enter_invite_code_title = /** @type {(inputs: Enter_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入邀請碼`)
};

/**
* | output |
* | --- |
* | "Enter Invite Code" |
*
* @param {Enter_Invite_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const enter_invite_code_title = /** @type {((inputs?: Enter_Invite_Code_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Invite_Code_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enter_invite_code_title(inputs)
	if (locale === "ar") return ar_enter_invite_code_title(inputs)
	if (locale === "de") return de_enter_invite_code_title(inputs)
	if (locale === "es") return es_enter_invite_code_title(inputs)
	if (locale === "fr") return fr_enter_invite_code_title(inputs)
	if (locale === "it") return it_enter_invite_code_title(inputs)
	if (locale === "ja") return ja_enter_invite_code_title(inputs)
	if (locale === "ko") return ko_enter_invite_code_title(inputs)
	if (locale === "pt_br") return pt_br_enter_invite_code_title(inputs)
	if (locale === "ru") return ru_enter_invite_code_title(inputs)
	if (locale === "th") return th_enter_invite_code_title(inputs)
	if (locale === "tr") return tr_enter_invite_code_title(inputs)
	if (locale === "zh_cn") return zh_cn_enter_invite_code_title(inputs)
	return zh_tw_enter_invite_code_title(inputs)
});